import { error } from 'console';
/* eslint-disable max-len */
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, tap } from 'rxjs';
import {
  AttendeeInformation,
  EventRequest,
  FeedbackInterface,
  FirstAider,
  FloorPlanInfo,
  ForwardEventRequest,
  MsProblemReport,
  OrganisationInformation,
  Place,
  PlaceAvatar,
  RecurrencePattern,
  SearchRequestNew,
  UserInformation,
  UserPreferences,
  UserSettings,
} from 'src/app/interfaces/interfaces';
import { CalendarEvent } from 'src/app/interfaces/interfaces';
import { environment } from 'src/environments/environment';
import { FeedbackService } from '../feedback-service/feedback.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient, private injector: Injector) {}

  getPlaceById(id: string): Observable<Place> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<Place>(environment.baseUrl + `/api/places/${id}`, {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getPlacesAvailability(searchRequest: SearchRequestNew): Observable<Place[]> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<Place[]>(
        environment.baseUrl + '/api/calendarManager/placesAvailablity',
        searchRequest,
        { headers: header }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw err.error;
        })
      );
  }
  
  getOnePlaceAvailability(
    startTime: Date,
    endTime: Date,
    recurrencePattern: RecurrencePattern,
    oldStartTime: Date,
    oldEndTime: Date,
    place: Place
  ): Observable<boolean> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    const OnePlaceAvailabilityRequest = {
      startTime,
      endTime,
      recurrencePattern,
      oldStartTime,
      oldEndTime,
      place,
    };
    return this.http
      .post<boolean>(
        environment.baseUrl + '/api/calendarManager/onePlaceAvailability',
        OnePlaceAvailabilityRequest,
        { headers: header }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getWeatherByCity(city: string, language: string): Observable<any> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<any>(
        environment.baseUrl + `/api/weather?city=${city}&language=${language}`,
        { headers: header }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getCitySuggestions(searchTerm: string): Observable<any> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<any>(
        environment.baseUrl + `/api/weather/search?query=${searchTerm}`,
        { headers: header }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  checkPlaceAvailability(
    email: string,
    startTime: string,
    endTime: string,
    isOnPrem: boolean,
    oldStartTime = '',
    oldEndTime = '',
    oldsubject = '',
    timeZoneId = ''
  ): Observable<boolean> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<boolean>(
        environment.baseUrl +
          '/api/places/' +
          email +
          '/available?startTime=' +
          startTime +
          '&endTime=' +
          endTime +
          '&isOnPrem=' +
          isOnPrem +
          '&oldStartTime=' +
          oldStartTime +
          '&oldEndTime=' +
          oldEndTime +
          '&oldsubject=' +
          oldsubject +
          '&timeZoneId' +
          timeZoneId,
        { headers: header }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  checkOrgTeamsConnector() {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<boolean>(environment.baseUrl + '/api/connector/canBookOnline', {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  checkPlaceAvailabilityAndTillEndOfDay(
    email: string,
    endOfTheDay: string,
    startTime: string,
    endTime: string,
    isOnPrem: boolean,
    oldStartTime = '',
    oldEndTime = '',
    oldsubject = '',
    timeZoneId = ''
  ): Observable<boolean> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<boolean>(
        environment.baseUrl +
          '/api/places/' +
          email +
          '/availableAndTillTheEnd?endOfTheDay=' +
          endOfTheDay +
          '&startTime=' +
          startTime +
          '&endTime=' +
          endTime +
          '&isOnPrem=' +
          isOnPrem +
          '&oldStartTime=' +
          oldStartTime +
          '&oldEndTime=' +
          oldEndTime +
          '&oldsubject=' +
          oldsubject +
          '&timeZoneId=' +
          timeZoneId,
        { headers: header }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getBookingsFromMyCalendarManager() {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<CalendarEvent[]>(
        environment.baseUrl + '/api/calendarManager/events',
        {
          headers: header,
        }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw err.error;
        })
      );
  }

  InvitationRespond(eventId, userResponse: string) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<CalendarEvent[]>(
        environment.baseUrl + '/api/me/event/' + eventId + '/' + userResponse,
        {},
        { headers: header }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      );
  }

  createCalendarEvent(eventRequest: EventRequest): Observable<any> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<any>(environment.baseUrl + '/api/me/event', eventRequest, {
        headers: header,
        observe: 'response',
      })
      .pipe(
        tap((response) => {
          if (response.status == 201) {
            this.injector.get(FeedbackService).addBookingCount();
          }
        }),
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  createCalendarEventNew(eventRequest: EventRequest, isOnPrem: Boolean) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<any>(
        environment.baseUrl + '/api/me/CreateEventNew?isOnPrem=' + isOnPrem,
        eventRequest,
        { headers: header, observe: 'response' }
      )
      .pipe(
        map((response) => {
          if (response.status == 201) {
            this.injector.get(FeedbackService).addBookingCount();
          }
        }),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      );
  }

  editCalendarEvent(id: string, placeEvent: EventRequest) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .put<EventRequest>(
        environment.baseUrl + '/api/me/event/' + id,
        placeEvent,
        { headers: header }
      )
      .pipe(
        map((placesEvent) => placesEvent),
        catchError((err: HttpErrorResponse) => {
          throw err;
        })
      );
  }

  deleteCalendarEvent(id: string) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .delete<boolean>(environment.baseUrl + '/api/me/event/' + id, {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw err;
        })
      );
  }

  getUserInformation() {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<UserInformation>(environment.baseUrl + '/api/me', {
        headers: header,
      })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw err.error;
        })
      );
  }

  sendUserFeedback(feedback: any) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<FeedbackInterface>(
        environment.baseUrl + '/api/feedback',
        feedback,
        { headers: header, observe: 'response' }
      )
      .pipe(
        tap((response) => {
          if (response.status == 201) {
            this.injector.get(FeedbackService).stopReminder();
          }
        }),
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getAllAttendeesList() {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<AttendeeInformation[]>(environment.baseUrl + '/api/attendees', {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  checkAttendeeAvailability(
    upnList: string[],
    startTime: string,
    endTime: string,
    oldStartTime = '',
    oldEndTime = ''
  ): Observable<{ [key: string]: boolean }> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<{ [key: string]: boolean }>(
        environment.baseUrl +
          '/api/attendees' +
          '/available?startTime=' +
          startTime +
          '&endTime=' +
          endTime +
          '&oldStartTime=' +
          oldStartTime +
          '&oldEndTime=' +
          oldEndTime +
          '&oldsubject=',
        upnList,
        { headers: header }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  sendContactForm(form: any) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<any>(environment.baseUrl + '/api/account/contact/send', form, {
        headers: header,
        observe: 'response',
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  sendProblemTicket(form: any) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<any>(environment.baseUrl + '/api/support/problem/send', form, {
        headers: header,
        observe: 'response',
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  sendIdeaTicket(form: any) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<any>(environment.baseUrl + '/api/support/idea/send', form, {
        headers: header,
        observe: 'response',
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getPlaceScheduleById(id: string, start, end): Observable<any> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<Place>(
        environment.baseUrl +
          `/api/places/${id}/availabletimes?start=${start}&end=${end}`,
        { headers: header }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getAvailibilityToExtendMeeting(
    id: string,
    start,
    end,
    isOnPrem: boolean
  ): Observable<any> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<Place>(
        environment.baseUrl +
          `/api/places/${id}/extendEventAvailableTimes?start=${start}&end=${end}&isOnPrem=${isOnPrem}`,
        { headers: header }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw err.error;
        })
      );
  }

  toggleFavoritePlace(placeUPN: string) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<any>(
        environment.baseUrl + `/api/places/${placeUPN}/favorite/toggle`,
        {},
        { headers: header, observe: 'response' }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getAllPlacesEmailAdress() {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<String[]>(environment.baseUrl + '/api/places/allPlacesEmailAdress', {
        headers: header,
      })
      .pipe(
        (res) => res,
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getFloorPlanInfo(): Observable<FloorPlanInfo[]> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<any>(environment.baseUrl + '/api/floorplan/info', {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getFloorPlanSchedule(places: string[]): Observable<any[]> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );

    return this.http
      .post<any>(
        environment.baseUrl + '/api/calendarManager/map',
        places,
        { headers: header }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw err.error;
        })
      );
  }

  getUserPreferences(): Observable<UserPreferences> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<UserPreferences>(environment.baseUrl + '/api/userSettings', {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  updateUserSettings(userSettings: UserSettings) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .put<void>(
        environment.baseUrl + '/api/userSettings/settings',
        userSettings,
        {
          headers: header,
        }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  toggleMapFavorite(mapId: string) {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .put(
        environment.baseUrl + '/api/userSettings/favorite-maps/' + mapId,
        {},
        { headers: header }
      )
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getAvatarlacesForPlaces(): Observable<PlaceAvatar[]> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<any>(environment.baseUrl + '/api/places/avatars', {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getActionGroupMembers(): Observable<FirstAider[]> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<FirstAider[]>(
        environment.baseUrl + '/api/calendarManager/first-aiders',
        {
          headers: header,
        }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw err.error;
        })
      );
  }

  getOrganisationNewsArticles(): Observable<any[]> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<any>(environment.baseUrl + '/api/newsarticles', {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  getEventAttachment(eventId: string): Observable<any[]> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<any>(
        environment.baseUrl + '/api/me/event/' + eventId + '/attachments',
        {
          headers: header,
        }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw err.error;
        })
      );
  }

  getEventAttachmentFile(
    eventId: string,
    attachmentId: string
  ): Observable<Blob> {
    const header: HttpHeaders = new HttpHeaders().append('Accept', '*/*');
    return this.http
      .get(
        environment.baseUrl + '/api/me/event/' + eventId + '/' + attachmentId,
        {
          headers: header,
          responseType: 'blob',
        }
      )
      .pipe(
        catchError(async (err: HttpErrorResponse) => {
          const apiErr = JSON.parse(await (err.error as Blob).text());
          throw apiErr;
        })
      );
  }

  getOrganisationInformation(): Observable<OrganisationInformation> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .get<OrganisationInformation>(environment.baseUrl + '/api/organisation', {
        headers: header,
      })
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }

  public reportMSProblem(problem: MsProblemReport): Observable<void> {
    const header: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
    return this.http
      .post<void>(
        environment.baseUrl + '/api/support/ms-problem/send',
        problem,
        { headers: header }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          throw new err.error();
        })
      );
  }
  forwardEvent(body: ForwardEventRequest) {
    const headers: HttpHeaders = new HttpHeaders().append(
      'Content-Type',
      'application/json; charset=UTF-8'
    );
  
    return this.http
      .post<any>(
        `${environment.baseUrl}/api/me/forwardEvent`,
        body,
        { headers }
      )
      .pipe(
        catchError((err) => {
          throw new err.message;
        })
      );
  }
  
}
